/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import Monster from "model/monster/Monster"
import Attributes from "model/stats/Attributes";
import Section from "model/abilities/Section";

export const handleSpellCasting = (ability: Ability, mon: Monster) => {
    // In case of spellcasting
    if (!ability.name.toLowerCase().includes("spellcasting") || !ability.desc.includes("\n")) {
        return;
    }
    ability.desc = ability.desc.split("•").join("* "); // replace bullet points with '* ', the markdown will convert back to bullet.
    const spellcastingAbility: string  = ability.desc.toLowerCase().includes("ability is intelligence") ? "Intelligence" :
                                            ability.desc.toLowerCase().includes("ability is wisdom") ? "Wisdom" :
                                            ability.desc.toLowerCase().includes("ability is charisma") ? "Charisma" : '';

    if (spellcastingAbility != '') {
        ability.attribute = spellcastingAbility;
        const attributeLevel = parseInt(mon.attributes[spellcastingAbility.toLowerCase() as keyof Attributes]);
        if (attributeLevel) {
            const bonus = Attributes.getBonus(attributeLevel) + mon.proficiencyBonus;
            const dc = 'DC ' + (8 + bonus);
            const toHit = (bonus >= 0 ? '\\+' : '') + bonus + ' to hit';
            const abilityShort = spellcastingAbility.substring(0, 3).toUpperCase();
            // Use replace with global regular expressions
            const dcRegex = new RegExp(dc, 'g');
            const toHitRegex = new RegExp(toHit, 'g');
            const spellSave = `DC [${abilityShort} SAVE]`;
            const spellAttack = `[${abilityShort} ATK] to hit`;

            ability.desc = ability.desc.replace(dcRegex, spellSave)
                                        .replace(toHitRegex, spellAttack)
                                        .replace(`${spellSave}\n ${spellAttack}`, spellSave + ' ' + spellAttack);
        }
    }

    // For hag covens
    let postDesc = "";
    if (ability.name.toLowerCase().includes("shared spellcasting")) {
        const lastLineBreak = ability.desc.lastIndexOf("\n\n");
        postDesc = ability.desc.substring(lastLineBreak).trim();
        ability.desc = ability.desc.substring(0, lastLineBreak);
    }

    const firstLineBreak = ability.desc.indexOf("\n");
    const spellcastingDesc = ability.desc.substring(0, firstLineBreak).trim();
    const spellcastingSpells = ability.desc.substring(firstLineBreak).trim();

    const spellsArr = spellcastingSpells.split("\n");
    for (let index = 0; index < spellsArr.length; index++) {
        const colonLoc = spellsArr[index].indexOf(':');
        if (colonLoc > 0) {
            const spaceAfterColonLoc = spellsArr[index].indexOf(' ', colonLoc);
            if (spaceAfterColonLoc > 0) {
                let header = spellsArr[index].substring(0, spaceAfterColonLoc).trim();
                let body = spellsArr[index].substring(spaceAfterColonLoc).trim();
                // make the body (the list of spells) in italic
                body = " _" + body + "_";

                // Anything in parenthesis should be un-italicized:
                body = body.split("(").join("_(");
                body = body.split(")").join(")_");
                if (!header.startsWith('* ') && !header.startsWith('- ')) {
                    header = '* ' + header;
                }
                spellsArr[index] = header + body;
            }
        }
    }

    ability.desc = spellcastingDesc + "\n" + spellsArr.join("\n");

    // For hag covens
    if (postDesc.length > 0) {
        ability.desc += "\n\n" + postDesc;
    }
    ability.desc = Section.convertSpellsToTable(ability.desc);
}
